import { useUserStore } from '@/stores/user';
import { UserGroup } from '@/types';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useImpersonation() {
  const route = useRoute();
  const userStore = useUserStore();

  const impersonatedUserId = computed(() => route.query.ownerId as string);
  const isImpersonation = computed(
    () =>
      userStore.userGroups.includes(UserGroup.CUSTOMER_SERVICE_AGENT) &&
      !!impersonatedUserId.value &&
      impersonatedUserId.value !== userStore.userId,
  );
  const ownerId = computed(() =>
    isImpersonation.value ? impersonatedUserId.value : userStore.userId,
  );

  return {
    ownerId,
    isImpersonation,
  };
}
